"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* "Save as template": turns a sent message into a template body. The server
 * (SuggestTemplateBlanks) finds the details that probably belong to one
 * patient; the sender's own name is found here. Each detail is a blank the
 * user can turn on, which swaps its text for a {{variable}}. */




// Letters, combining marks, digits and "_" continue a word.
const WORD_CHAR = /[\p{L}\p{M}\p{N}_]/u

const isWordChar = (char) => !!char && WORD_CHAR.test(char)

// The code point just before or at a string index (surrogate pairs kept whole).
const charBefore = (text, index) => [...text.slice(Math.max(0, index - 2), index)].pop()
const charAt = (text, index) => [...text.slice(index, index + 2)][0]

/* The name that stands for {{staff_name}} in a saved message: the sender's,
 * only when staff sent it. A patient's or web visitor's own message keeps
 * their name for the patient variables instead. */
 const staffNameForMessage = (senderType, senderName) =>
  senderType === 'user' ? _nullishCoalesce(senderName, () => ( '')) : ''; exports.staffNameForMessage = staffNameForMessage

/* Where the sender's name appears: whole word, case-sensitive. Blank and
 * one-letter names find nothing. */
 const staffNameBlanks = (text, staffName) => {
  const name = staffName.trim()
  if ([...name].length < 2) return []
  const blanks = []
  for (let i = text.indexOf(name); i >= 0; i = text.indexOf(name, i + 1)) {
    const end = i + name.length
    if (!isWordChar(charBefore(text, i)) && !isWordChar(charAt(text, end))) {
      blanks.push({ Start: i, End: end, Text: name, Kind: 'name', Variable: 'staff_name', Confidence: 'high', Score: 1 })
    }
  }
  return blanks
}; exports.staffNameBlanks = staffNameBlanks

/* The server's blanks and the sender's name together, in order. The sender's
 * name wins where they overlap. */
 const mergeBlanks = (server, local) =>
  [...local, ...server.filter(s => !local.some(l => s.Start < l.End && l.Start < s.End))]
    .sort((a, b) => a.Start - b.Start); exports.mergeBlanks = mergeBlanks

/* The variables Save as template fills in before the user does anything, as
 * it always has: the sender's name, and the chat's only patient's names when
 * they're certain (not "Will" starting a question in Will's chat). */
 const defaultBlanksOn = (blanks, onlyOnePatient) =>
  blanks.map(b => b.Variable === 'staff_name' ||
    (onlyOnePatient && b.Confidence === 'high' && (b.Variable === 'first_name' || b.Variable === 'last_name'))); exports.defaultBlanksOn = defaultBlanksOn

/* The choices to keep when a check comes back for the same text: a blank
 * the user already had (same place, same variable) keeps its on/off; a new
 * one starts at its default. Checking a different text starts over. */
const blankKey = (b) => `${b.Start}:${b.End}:${b.Variable}`

 const carryBlanksOn = (
  previous,
  base,
  blanks,
  defaults,
) => blanks.map((b, i) => {
  if (previous.base !== base) return !!defaults[i]
  const at = previous.blanks.findIndex(p => blankKey(p) === blankKey(b))
  return at >= 0 ? !!previous.on[at] : !!defaults[i]
}); exports.carryBlanksOn = carryBlanksOn

/* Where one blank sits in the body: its {{variable}} when on, its text when off. */







/* The text with the blanks that are on swapped for their variables, and where
 * every blank ended up. */
 const applyBlanks = (text, blanks, on) => {
  let body = ''
  let from = 0
  const marks = []
  blanks.forEach((blank, index) => {
    body += text.slice(from, blank.Start)
    const piece = on[index] ? `{{${blank.Variable}}}` : text.slice(blank.Start, blank.End)
    marks.push({ index, start: body.length, end: body.length + piece.length, on: !!on[index] })
    body += piece
    from = blank.End
  })
  return { body: body + text.slice(from), marks }
}; exports.applyBlanks = applyBlanks

/* "Blank all": every high-confidence blank on; low ones as they were. */
 const blankAllOn = (blanks, on) =>
  blanks.map((b, i) => b.Confidence === 'high' || !!on[i]); exports.blankAllOn = blankAllOn

const details = (n) => `${n} ${n === 1 ? 'detail' : 'details'}`

/* The line under the message: what's still literal and what's been blanked. */






 const BLANK_CHECK_FAILED = { kind: 'failed', text: "Couldn't check for patient details." }; exports.BLANK_CHECK_FAILED = BLANK_CHECK_FAILED

 const blankNotice = (blanks, on) => {
  const off = blanks.filter((_, i) => !on[i])
  const high = off.filter(b => b.Confidence === 'high').length
  const low = off.length - high
  const blanked = blanks.length - off.length
  if (high > 0) return { kind: 'detected', text: `${details(high)} ${high === 1 ? 'looks' : 'look'} patient-specific.`, canBlankAll: true }
  if (low > 0 && blanked > 0) {
    return { kind: 'detected', text: `Blanked ${details(blanked)}. ${low} more might be patient-specific.`, canBlankAll: false }
  }
  if (low > 0) return { kind: 'detected', text: `${details(low)} might be patient-specific.`, canBlankAll: false }
  if (blanked > 0) return { kind: 'blanked', text: `Blanked ${details(blanked)} so it works for the next patient.` }
  return null
}; exports.blankNotice = blankNotice
